// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__EJKrY","detailsBorder":"styles_detailsBorder__2hEQa"};